export const LOCATIONS = "Location";
export const WORK_CENTERS = "Work Center";
export const USER_ROLES = "User Roles";
export const USER_STATUS = "Status";
export const JOB_ROLES = "Job Role";
export const SKILL_PRIORITIES = "Skill Priorities";
export const SKILLS = "Skill";
export const CERTIFICATIONS = "Certification";
export const STATUS = "Shift Status";
export const SHIFT_BY = "Shift Type";
export const PUBLISHED_BY = "Published By";
export const REPORTING_TO = "Reporting Manager";
export const PRIMARY_JOB_ROLES = "Primary Job";
export const WORKER_TYPES = "Worker Type";
export const WORKER_SUB_TYPES = "Worker Sub Type";
export const WORKER_STATUS = "Worker Status";
export const SHIFT_PATTERNS = "Shift Pattern";
export const OVERTIME_AVAILABILITY = "Overtime Availability";
export const APPLIED_FILTERS_HEIGHT = 57;
export const SCHEDULER_INFO_BAR_HEIGHT = 33;
